import InitComponent from "Modules/InitComponent";
import store from "Stores/store";
import CounselorGrid from "./components/CounselorGrid.vue";

const counselorGrid = document.querySelector(".counselor-grid__app");

if (counselorGrid) {
  const {
    label,
    pluralLabel,
    role,
    competence,
    adminMarket,
    siteId,
    slimTemplate,
    displayPhoneNumber,
    isCityPage,
  } = counselorGrid.dataset;

  const initComponent = new InitComponent({
    components: { CounselorGrid },
    data: {
      adminMarket,
      competence,
      displayPhoneNumber,
      isCityPage,
      label,
      pluralLabel,
      role,
      siteId,
      slimTemplate,
    },
    selectors: counselorGrid,
    store,
    template: "<CounselorGrid />",
  });

  initComponent.init();
}
